import { useEffect } from 'react'

const ConsoleError = () => {
  useEffect(() => {
    const error = console.error
    console.error = (...args: string[]) => {
      if (/Support for defaultProps will be removed from/.test(args[0])) return
      error(...args)
    }
  }, [])

  return null
}

export default ConsoleError
